export const BASE_FONT_FAMILY = "Inter";
export const SELF_HOSTED_FONT_FAMILIES = Object.freeze([BASE_FONT_FAMILY, "Montserrat", "Poppins", "Roboto"]);

const GOOGLE_FONT_REQUESTS = Object.freeze({
  Inter: "Inter:wght@400;500;600;700;800",
  "Abril Fatface": "Abril+Fatface",
  Anton: "Anton",
  "Archivo Black": "Archivo+Black",
  Arimo: "Arimo:wght@400;500;600;700",
  "Bebas Neue": "Bebas+Neue",
  Caveat: "Caveat:wght@400;500;600;700",
  Cinzel: "Cinzel:wght@400;500;600;700;800;900",
  "Cormorant Garamond": "Cormorant+Garamond:wght@400;500;600;700",
  "DM Sans": "DM+Sans:wght@400;500;600;700;800;900",
  "Dancing Script": "Dancing+Script:wght@400;500;600;700",
  "Josefin Sans": "Josefin+Sans:wght@400;500;600;700",
  "Julius Sans One": "Julius+Sans+One",
  "League Gothic": "League+Gothic",
  "League Spartan": "League+Spartan:wght@400;500;600;700;800;900",
  "Libre Baskerville": "Libre+Baskerville:wght@400;700",
  Lora: "Lora:wght@400;500;600;700",
  Merriweather: "Merriweather:wght@400;700;900",
  Montserrat: "Montserrat:wght@400;500;600;700;800;900",
  "Open Sans": "Open+Sans:wght@400;500;600;700;800",
  Oswald: "Oswald:wght@400;500;600;700",
  Pacifico: "Pacifico",
  "Playfair Display": "Playfair+Display:wght@400;500;600;700;800;900",
  Poppins: "Poppins:wght@400;500;600;700;800;900",
  Raleway: "Raleway:wght@400;500;600;700;800;900",
  Roboto: "Roboto:wght@400;500;600;700;800;900",
  "Roboto Condensed": "Roboto+Condensed:wght@400;500;600;700;800;900",
});

export const PROJECT_FONT_FAMILIES = Object.freeze(Object.keys(GOOGLE_FONT_REQUESTS));
export const TEMPLATE_FONT_OPTIONS = PROJECT_FONT_FAMILIES.map(value => ({
  label: value, style: { fontFamily: value }, value,
}));

export const resolveFontFamilies = (families = []) => {
  const requested = new Set(families.flatMap(value => typeof value === "string"
    ? value.split(",").map(name => name.trim().replace(/^["']|["']$/g, "").toLowerCase()) : []));
  return PROJECT_FONT_FAMILIES.filter(name => requested.has(name.toLowerCase()));
};

export const getGoogleFontsStylesheetUrl = (families) => {
  const requests = resolveFontFamilies(families).map(name => `family=${GOOGLE_FONT_REQUESTS[name]}`);
  return requests.length ? `https://fonts.googleapis.com/css2?${requests.join("&")}&display=swap` : "";
};

export const BASE_FONT_PRELOAD_URL = "/fonts/inter-v20/latin-c940764593d0.woff2";
